export const ConsultationStatusEnum = {
  RECORDING: {
    value: "RECORDING",
    description: 'Recording',
    color: 'rgb(255, 200, 200)',
    colorFamily: 'orange',
  },
  PENDING: {
    value: "PENDING",
    description: 'Pending Processing',
    color: 'rgb(254, 255, 196)',
    colorFamily: 'yellow',
  },
  GENERATING: {
    value: "GENERATING",
    description: 'Processing',
    color: 'rgb(255, 215, 196)',
    colorFamily: 'amber',
  },
  READY: {
    value: "READY",
    description: 'Ready for Review',
    color: 'rgb(196, 255, 211)',
    colorFamily: 'green',
  },
  QUEUED_FOR_FILING: {
    value: "QUEUED_FOR_FILING",
    description: 'Queued for Filing',
    color: 'rgb(180, 220, 255)',
    colorFamily: 'blue',
  },
  INVALID: {
    value: "INVALID",
    description: 'Invalid',
    color: 'rgb(255, 140, 140)',
    colorFamily: 'red',
  },
  ABANDONED: {
    value: "ABANDONED",
    description: 'Abandoned',
    color: 'rgb(200, 200, 200)',
    colorFamily: 'gray',
  },
  FILED_AWAY: {
    value: "FILED_AWAY",
    description: 'Filed Away',
    color: 'rgb(230, 204, 255)',
    colorFamily: 'purple',
  }
};

export const NotesModeEnum = {
  BRIEF: {
    value: "BRIEF",
    description: 'Brief',
  },
  MEDIUM: {
    value: "MEDIUM",
    description: 'Medium',
  },
  DETAILED: {
    value: "DETAILED",
    description: 'Detailed',
  }
};
